import { apolloClient } from "@/apollo-client/ApolloClient";
import {
  ActualChangeForPriceRowQuery,
  ActualChangeForPriceRowQueryVariables,
} from "@/gql/graphql";
import { actualChangeForPriceRowQuery } from "../rate-sheet/thunks/FetchActualChangeForSinglePriceRow";

export const fetchCalculateNewPriceForRows = async (
  variables: ActualChangeForPriceRowQueryVariables
) =>
  apolloClient.query<
    ActualChangeForPriceRowQuery,
    ActualChangeForPriceRowQueryVariables
  >({
    query: actualChangeForPriceRowQuery,
    fetchPolicy: "network-only",
    variables,
  });
